var news = {

    init: function () {
        news.items();

        $('[data-news] [name]').on('change', () => {
            items.update('news');
            items.update('news-block');
        });
    },

    filter: function () {
        var data = {
            paginate: 8
        };

        if ($('[data-news] [name="industry_id"]:checked').length) {
            data.industry_id = $('[data-news] [name="industry_id"]:checked').val();
        }

        return data;
    },

    html: function (html, data) {
        html.find('[html-img]').html('<img src="' + data.image + '">');

        return html;
    },

    items: function () {
        ZoneObject.create('.section-news', {
            run: () => {
                items.create({
                    name: 'news',
                    scroll_window: location.href.indexOf('/news') > -1,
                    first_load: true,
                    data: news.filter,
                    html: news.html
                });
            }
        });

        ZoneObject.create('.newsitems-block', {
            run: () => {
                items.create({
                    name: 'news-block',
                    first_load: true,
                    data: {
                        paginate: 4
                    },
                    html: news.html
                });
            }
        });
    }

}

$(news.init);